import React from "react";

import styles from "./style.module.css";

import { Button } from "aible";

import { ALERT_TYPES } from "containers/Monitoring/reducer";

export default class AlertCard extends React.PureComponent {
  getLabel() {
    const { data, setupLabels } = this.props;
    let retLabel = "";
    if (setupLabels) {
      switch (data.type) {
        case ALERT_TYPES.TRANSACTION_COUNT:
          retLabel = setupLabels.transactionLabel + " Count";
          break;
        case ALERT_TYPES.SUCCESS_RATE:
          retLabel = setupLabels.outcomeLabel + " Rate";
          break;
      }
    } else {
      retLabel = data.type;
    }
    return retLabel;
  }

  render() {
    const label = this.getLabel();
    return (
      <div className={styles.alertCardWrapper}>
        <AlertCardHeader alertLabel={label} {...this.props} />
        <AlertCardBody alertLabel={label} {...this.props} />
      </div>
    );
  }
}

class AlertCardHeader extends React.PureComponent {
  getHeader() {
    const { data, alertLabel } = this.props;
    let retHeader = alertLabel;
    let modifier = " ";
    if (data.value > 0) {
      modifier += "is Higher than Expected";
    } else {
      modifier += "is Lower than Expected";
    }
    return retHeader + modifier;
  }

  render() {
    return <div className={styles.alertCardHeader}>{this.getHeader()}</div>;
  }
}

class AlertCardBody extends React.PureComponent {
  getContent() {
    const { data, timePeriod, alertLabel } = this.props;
    const retContent = [];

    const valuePercentage = (Math.abs(data.value) * 100).toFixed(1);
    const timePercentage = (data.time * 100).toFixed(1);

    const retTimePeriod = timePeriod || "time period";

    let message = "You're " + timePercentage + "% of the way into the " + retTimePeriod + " and you have a ";
    if (data.value > 0) {
      message += valuePercentage + "% higher ";
    } else {
      message += valuePercentage + "% lower ";
    }
    message += alertLabel + " than expected.";
    retContent.push(message);

    retContent.push(
      "Aible recommends adjusting the expected " + alertLabel + " to have more accurate business predictions."
    );
    return retContent;
  }
  render() {
    const { adjustAssumptions, hideAdjust } = this.props;
    return (
      <div className={styles.alertCardBody}>
        {this.getContent().map((text, i) => (
          <div className={styles.alertCardContent} key={text}>
            {text}
          </div>
        ))}
        {!hideAdjust && (
          <div className={styles.alertCardFooter}>
            <Button onClick={() => adjustAssumptions()} style={{ width: "100%" }}>
              {"Adjust Assumptions"}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
